import { render, staticRenderFns } from "./user-requests.vue?vue&type=template&id=be3f5804&"
import script from "./user-requests.ts?vue&type=script&lang=js&"
export * from "./user-requests.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports